"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Frequency = exports.FrequencyUnitTexts = exports.FrequencyUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var FrequencyUnits;
(function (FrequencyUnits) {
    FrequencyUnits["default"] = "hz";
    FrequencyUnits["hz"] = "hz";
    FrequencyUnits["_s"] = "_s";
    FrequencyUnits["_h"] = "_h";
})(FrequencyUnits = exports.FrequencyUnits || (exports.FrequencyUnits = {}));
exports.FrequencyUnitTexts = {
    [FrequencyUnits.default]: 'hz',
    [FrequencyUnits.hz]: 'hz',
    [FrequencyUnits._s]: '1/s',
    [FrequencyUnits._h]: '1/h',
};
class Frequency extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Frequency';
        this.defaultUnit = 'hz';
        this.unitTexts = exports.FrequencyUnitTexts;
    }
    static getUnitText(unit) {
        return exports.FrequencyUnitTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(FrequencyUnits).includes(q.Unit)) {
            throw new Error(`Frequency.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Frequency(q);
    }
    static hz(v) {
        return new Frequency(v, FrequencyUnits.hz);
    }
    static _s(v) {
        return new Frequency(v, FrequencyUnits._s);
    }
    static _h(v) {
        return new Frequency(v, FrequencyUnits._h);
    }
    set hz(v) {
        this.value = +v;
        this.unit = FrequencyUnits.hz;
    }
    get hz() {
        switch (this.unit) {
            case FrequencyUnits.hz:
                return this.value;
            case FrequencyUnits._s:
                return this.value;
            case FrequencyUnits._h:
                return this.value / 3600;
        }
        throw new Error(`${this.className}.hz: unknown unit ${this.unit}`);
    }
    set _s(v) {
        this.value = +v;
        this.unit = FrequencyUnits._s;
    }
    get _s() {
        return this.unit === FrequencyUnits._s ? this.value : this.hz;
    }
    set _h(v) {
        this.value = +v;
        this.unit = FrequencyUnits._h;
    }
    get _h() {
        return this.unit === FrequencyUnits._h ? this.value : this.hz * 3600;
    }
    clone() {
        return Frequency.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case FrequencyUnits.hz:
                return this.hz;
            case FrequencyUnits._s:
                return this._s;
            case FrequencyUnits._h:
                return this._h;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.Frequency = Frequency;
Frequency.units = FrequencyUnits;
//# sourceMappingURL=Frequency.js.map